// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260704/js/" + chunkId + "." + {"44":"0cade885","225":"9f7ff43e","481":"8992d2eb","486":"85d4befc","770":"84585b1e"}[chunkId] + ".0.7372948670036045.chunk.js";
};